import { createTheme } from "@mui/material/styles";

// assets

// project imports
import overrideMuiStyle from "./overrideMui";

export const theme = () => {
  const themes = createTheme();
  themes.components = overrideMuiStyle();

  return themes;
};

export default theme;
